<script setup>
import { useAppStore } from '@/stores/app'
import { useDataStore } from '@/stores/data'
import BasePage from './BasePage.vue'
import { ref, watch, onMounted, onUnmounted } from 'vue'

const appStore = useAppStore()
const dataStore = useDataStore()
const frameLoaded = ref(false)
const surveyState = ref({
	questionText: '',
	hasNextButton: false,
	hasPrevButton: false,
	hasErrors: false,
	errorText: '',
})

var progressCompleted = false
var surveyReady = false

const handleMessage = (event) => {
	console.log('Received message:', event.data)

	// Ensure the message is from the trusted iframe origin
	if (event.origin !== 'https://survey.walr.com') {
		//console.warn('Received message from other origin:', event.origin)
		return
	}

	if (event.data.type == 'state') {
		surveyState.value = event.data.state
		frameLoaded.value = true
		console.warn('state recieved', event.data.state, 'completed', event.data.state.completed)

		// Special handling of events from the redirect survey page
		// if (event.data.state.surveyId == dataStore.surveyRedirectId) {
		// 	if (event.data.state.sampleId) {
		// 		dataStore.respondentShortId = event.data.state.sampleId
		// 		kettle.set('respondent_short_id', dataStore.respondentShortId)
		// 		loadSurvey()
		// 		console.warn('state redirect survey detected', dataStore.respondentShortId)
		// 		return
		// 	} else {
		// 		dataStore.respondentShortId = null
		// 		kettle.remove('respondent_alt_id')
		// 		console.warn('No sampleId in state for redirect survey')
		// 		appStore.toast({ message: 'En feil har oppstått. Ta kontakt med Opinion support på telefon 21 300 450 eller rvu@opinion.no', type: 'error', duration: 30000 })
		// 		dataStore.loadingSurvey = false
		// 		return
		// 	}
		// }

		// If state has the coorect surveyId then its definitely loaded
		if (event.data.state.surveyId == dataStore.surveyId) {
			surveyReady = true
			dataStore.loadingSurvey = false
			dataStore.surveyReady = true
		}

		// if (event.data.state.respondentId) {
		// 	dataStore.respondentId = event.data.state.respondentId
		// 	kettle.set('respondent_id', dataStore.respondentId)
		// 	appStore.startTracking()
		// }

		// if (event.data.state.questionId == 'FINAL') {
		// 	progressCompleted = true
		// 	appStore.surveyCompleted = true
		// 	//dataStore.currentProcess.progress = 100
		// 	kettle.set('survey_completed', 'true')

		// 	// Try to load the survey definitions
		// 	dataStore.loadSurveyDefinitions()
		// }

		// // Lets end the survey when we reach this question about where the user stayed yesterday
		// if (event.data.state.completed) {
		// 	// Set the user as onboarded the survey
		// 	kettle.set('onboarded_survey', 'true')
		// 	appStore.onboardedSurvey = true
		// 	appStore.setPage('intro')
		// 	progressCompleted = true
		// }

		// if (event.data.state.surveyId == dataStore.surveyId) {
		// 	//dataStore.currentProcess.progress = 100
		// 	progressCompleted = true
		// }

		// if (event.data.state.questionName == 'RVU_TILBAKEMELDING') {
		// 	event.data.state.completed = true
		// }

		if (event.data.state.completed) {
			progressCompleted = true
			appStore.surveyCompleted = true
			appStore.onboardedSurvey = true
			kettle.set('survey_completed', 'true')
			kettle.set('onboarded_survey', 'true')

			// If the survey is completed, and the user has onboarded permissions, we can set the page to intro
			if (appStore.onboardedPermissions) {
				appStore.setPage('intro')
			}

			console.warn('Survey completed')
			// Try to load the survey definitions
			dataStore.loadSurveyDefinitions()

			// Store the timestamp when the survey was completed
			dataStore.surveyCompletedDate = new Date().toISOString()
			kettle.set('survey_completed_date', dataStore.surveyCompletedDate)

			// Track the survey completed event
			appStore.events.trackSurveyCompleted()
		}

		// Tell the survey that its hosted inside an app
		postAction('app')
	}

	if (progressCompleted) {
		dataStore.currentProcess.progress = 100
		setTimeout(() => {
			if (!appStore.surveyCompleted) {
				// Show the bottom sheet with the survey page
				if (appStore.bottomSheet.currentState == 'hidden') {
					appStore.bottomSheet.autoResize()
					console.warn('SurveyPage: autoResize')
				}
			}
		}, 300)
	}

	if (event.data.type === 'error') {
		console.error('Error from iframe:', event.data.message)
		appStore.toast({ message: event.data.message, type: 'warning', duration: 5000 })
	}
}

const postAction = (action) => {
	const iframe = document.querySelector('iframe')
	if (iframe) {
		iframe.contentWindow.postMessage({ action: action }, '*')
	}
}

const setIframeUrl = (url, source) => {
	const iframe = document.querySelector('iframe')
	if (iframe) {
		if (iframe.src != url) {
			console.warn('Setting iframe url:', url, 'was', iframe.src)
			iframe.src = url
			iframe.onload = () => {
				console.warn('iframe loaded:', url)
				if (source == 'init') dataStore.currentProcess.progress = 10
				else dataStore.currentProcess.progress = 40

				// Store the timestamp when the survey was started
				dataStore.surveyStartedDate = new Date().toISOString()
				kettle.set('survey_started_date', dataStore.surveyStartedDate)
			}
		} else {
			console.warn('Iframe url already set to:', url)
		}
	}
}

const loadSurvey = (source) => {
	const iframe = document.querySelector('iframe')
	var surveyUrl = ''
	var baseUrl = 'https://survey.walr.com/'
	surveyUrl = baseUrl + dataStore.surveyShortId + '/' + dataStore.respondentShortId
	console.warn('loadSurvey', source, surveyUrl)
	dataStore.currentProcess.progress = 30
	if (iframe.src != surveyUrl) {
		setIframeUrl(surveyUrl, source)
	}
}

// const loadSurvey = (source) => {
// 	const iframe = document.querySelector('iframe')
// 	var surveyUrl = ''
// 	var baseUrl = 'https://survey.walr.com/'
// 	console.warn('loadSurvey', source, 'surveyShortId', dataStore.surveyShortId, 'surveyRedirectShortId', dataStore.surveyRedirectShortId, 'respondentShortId', dataStore.respondentShortId, 'respondentAltId', dataStore.respondentAltId)
// 	if (dataStore.respondentAltId && !dataStore.respondentShortId) {
// 		surveyUrl = baseUrl + dataStore.surveyRedirectShortId + '?id=' + dataStore.respondentAltId + '&callback=' + encodeURIComponent(location.href)
// 		appStore.bottomSheet.close()
// 		dataStore.currentProcess.progress = 0
// 	} else {
// 		if (dataStore.respondentShortId) surveyUrl = baseUrl + dataStore.surveyShortId + '/' + dataStore.respondentShortId
// 		dataStore.currentProcess.progress = 30
// 	}

// 	if (iframe.src != surveyUrl) {
// 		// dataStore.loadingSurvey = true
// 		// dataStore.surveyReady = false
// 		// if (!appStore.surveyCompleted) {
// 		// 	dataStore.currentProcess.process = 'Laster spørreundersøkelse...'
// 		// }
// 		setIframeUrl(surveyUrl, source)
// 	}
// }

const active = () => {
	console.warn('SurveyPage: active')
	initSurvey()
}

const initSurvey = async () => {
	if (appStore.surveyCompleted && appStore.onboardedSurvey) return
	if (dataStore.respondentAltId) {
		loadSurvey('watch')
	}
}

const unload = () => {
	if (appStore.surveyCompleted && appStore.onboardedSurvey && dataStore.respondentId && dataStore.respondentShortId) {
		setIframeUrl('', 'unload')
	}
}

onMounted(() => {
	window.addEventListener('message', handleMessage)
})

onUnmounted(() => {
	window.removeEventListener('message', handleMessage)
})

// Watch respondentShortId
// watch(
// 	() => dataStore.respondentAltId,
// 	async () => {
// 		console.warn('respondentAltId changed', dataStore.respondentAltId)
// 		if (dataStore.respondentAltId) {
// 			await dataStore.initRespondent()
// 			initSurvey()
// 		}
// 	},
// )

watch(
	() => dataStore.surveyShortId,
	async (newValue, oldValue) => {
		console.warn('surveyShortId changed', newValue, 'oldValue', oldValue)
		if (newValue && newValue !== oldValue) {
			initSurvey()
		}
	},
)
</script>

<template>
	<BasePage name="survey" @active="active()" @inactive="unload()" title="Spørreundersøkelse">
		<iframe id="iframe" credentialless sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-storage-access-by-user-activation" allow="cookies" style="opacity: 0" :class="{ loaded: frameLoaded }" allowTransparency="true"></iframe>
		<!-- <LoadingSpinner v-if="!frameLoaded"></LoadingSpinner> -->
		<template v-if="frameLoaded" #footer>
			<div v-if="surveyState.hasPrevButton" class="button full" @click="postAction('prev')">Forrige</div>
			<div v-if="surveyState.hasNextButton" class="button blue full" @click="postAction('next')">Neste</div>
		</template>
	</BasePage>
</template>
